// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.default-community-list-card-container {
  background: #ffffff;
  border-radius: 28px;
  margin-bottom: 20px;
  cursor: pointer;
  box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
  min-height: 15vh !important;
  height: 100% !important;
}

.default-community-list-card-button-container {
  display: flex;
  flex-direction: column !important;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 5px 10px;
  overflow-x: auto; /* Allow horizontal scroll if needed */
  width: 100%; /* Ensure it takes full width */
  box-sizing: border-box; /* Ensure padding is included inside width */
  /* hide scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}
.default-community-list-card-button-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.selected-community {
  border: 3.5px solid #4795de;
}

.make-default-button-follow-more-community {
  height: 30px;
  border-radius: 35px;
  text-transform: none !important;
  margin-right: 2px !important;
  outline: none !important;
  background-color: rgb(239, 238, 237);
  color: #4795debd;
  font-size: 13px;
  font-weight: 600;

  white-space: nowrap;
  min-width: auto;
  display: flex;
  align-items: center;
  border-width: 0px;
  padding: 4px 8px;
}
.follow-button-follow-more-community {
  height: 30px;
  border-radius: 10px;
  margin-right: 2px !important;
  outline: none !important;
  background-color: rgb(239, 238, 237);
  color: #4795debd;
  font-size: 13px;
  font-weight: 600;

  white-space: nowrap;
  min-width: auto;
  display: flex;
  align-items: center;
  border-width: 0px;
  padding: 4px 8px;
}
.follow-button-follow-more-private-community {
  height: 30px;
  border-radius: 10px;
  margin-right: 2px !important;
  outline: none !important;
  background-color: rgb(239, 238, 237);
  color: #4795debd;
  font-size: 13px;
  font-weight: 600;

  white-space: nowrap;
  min-width: auto;
  display: flex;
  align-items: center;
  border-width: 0px;
  padding: 4px 8px;
}
.unblock-button-follow-more-community {
  height: 30px;
  border-radius: 35px;
  margin-right: 2px !important;
  outline: none !important;
  background-color: rgb(239, 238, 237);
  color: #4795debd;
  font-size: 13px;
  font-weight: 600;

  white-space: nowrap;
  min-width: auto;
  display: flex;
  align-items: center;
  border-width: 0px;
  padding: 4px 15px;
}
.make-default-img-btn {
  height: 30px;
  border-radius: 10px;
  outline: none !important;
  background-color: rgb(239, 238, 237);

  white-space: nowrap;
  min-width: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-width: 0px;
  padding: 4px 8px;
}
.make-default-img-btn img {
  margin-right: -5px;
}

.view-activity-button-follow-more-community {
  height: 30px;
  border-radius: 35px;
  text-transform: none !important;
  outline: none !important;
  background-color: rgb(239, 238, 237);
  color: #4795debd;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  min-width: auto;
  border-width: 0px;
  padding: 4px 8px;
}

.make-default-image-follow-more-community {
  margin-right: 2px;
  height: 11px;
  margin-bottom: 3px;
  outline: none !important;
}

.default-community-list-card-image {
  border-radius: 28px;
  max-width: 100% !important;
  height: 15vh !important;
}
@media screen and (min-width: 768px) and (max-width: 1400px) {
  .follow-button-follow-more-private-community {
    font-size: 12px;
    margin-bottom: 5px;
    font-weight: 500;
  }
}

/* default (mobile / small screens) */
.community-name-default-list {
  font-size: 14px;
  font-weight: bold;
  color: #373334;
  height: 20px;
  display: block;
  width: 100%;
  min-width: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* apply width constraints only for ≥1024px */
@media (min-width: 1024px) {
  .community-name-default-list {
    max-width: 160px;
  }
}
@media (min-width: 1440px) {
  .community-name-default-list {
    max-width: 230px;
  }
}
@media (min-width: 1600px) {
  .community-name-default-list {
    max-width: 270px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/DefaultCommunity/communitiesList/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB,EAAE,sCAAsC;EACxD,WAAW,EAAE,+BAA+B;EAC5C,sBAAsB,EAAE,4CAA4C;EACpE,mBAAmB;EACnB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,gBAAgB;AAC5C;AACA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,oCAAoC;;EAEpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;;EAEZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".default-community-list-card-container {\r\n  background: #ffffff;\r\n  border-radius: 28px;\r\n  margin-bottom: 20px;\r\n  cursor: pointer;\r\n  box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);\r\n  min-height: 15vh !important;\r\n  height: 100% !important;\r\n}\r\n\r\n.default-community-list-card-button-container {\r\n  display: flex;\r\n  flex-direction: column !important;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  padding: 5px 10px;\r\n  overflow-x: auto; /* Allow horizontal scroll if needed */\r\n  width: 100%; /* Ensure it takes full width */\r\n  box-sizing: border-box; /* Ensure padding is included inside width */\r\n  /* hide scrollbar */\r\n  scrollbar-width: none; /* Firefox */\r\n  -ms-overflow-style: none; /* IE and Edge */\r\n}\r\n.default-community-list-card-button-container::-webkit-scrollbar {\r\n  display: none; /* Chrome, Safari, Opera */\r\n}\r\n\r\n.selected-community {\r\n  border: 3.5px solid #4795de;\r\n}\r\n\r\n.make-default-button-follow-more-community {\r\n  height: 30px;\r\n  border-radius: 35px;\r\n  text-transform: none !important;\r\n  margin-right: 2px !important;\r\n  outline: none !important;\r\n  background-color: rgb(239, 238, 237);\r\n  color: #4795debd;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n\r\n  white-space: nowrap;\r\n  min-width: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  border-width: 0px;\r\n  padding: 4px 8px;\r\n}\r\n.follow-button-follow-more-community {\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  margin-right: 2px !important;\r\n  outline: none !important;\r\n  background-color: rgb(239, 238, 237);\r\n  color: #4795debd;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n\r\n  white-space: nowrap;\r\n  min-width: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  border-width: 0px;\r\n  padding: 4px 8px;\r\n}\r\n.follow-button-follow-more-private-community {\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  margin-right: 2px !important;\r\n  outline: none !important;\r\n  background-color: rgb(239, 238, 237);\r\n  color: #4795debd;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n\r\n  white-space: nowrap;\r\n  min-width: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  border-width: 0px;\r\n  padding: 4px 8px;\r\n}\r\n.unblock-button-follow-more-community {\r\n  height: 30px;\r\n  border-radius: 35px;\r\n  margin-right: 2px !important;\r\n  outline: none !important;\r\n  background-color: rgb(239, 238, 237);\r\n  color: #4795debd;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n\r\n  white-space: nowrap;\r\n  min-width: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  border-width: 0px;\r\n  padding: 4px 15px;\r\n}\r\n.make-default-img-btn {\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  outline: none !important;\r\n  background-color: rgb(239, 238, 237);\r\n\r\n  white-space: nowrap;\r\n  min-width: 30px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-width: 0px;\r\n  padding: 4px 8px;\r\n}\r\n.make-default-img-btn img {\r\n  margin-right: -5px;\r\n}\r\n\r\n.view-activity-button-follow-more-community {\r\n  height: 30px;\r\n  border-radius: 35px;\r\n  text-transform: none !important;\r\n  outline: none !important;\r\n  background-color: rgb(239, 238, 237);\r\n  color: #4795debd;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  min-width: auto;\r\n  border-width: 0px;\r\n  padding: 4px 8px;\r\n}\r\n\r\n.make-default-image-follow-more-community {\r\n  margin-right: 2px;\r\n  height: 11px;\r\n  margin-bottom: 3px;\r\n  outline: none !important;\r\n}\r\n\r\n.default-community-list-card-image {\r\n  border-radius: 28px;\r\n  max-width: 100% !important;\r\n  height: 15vh !important;\r\n}\r\n@media screen and (min-width: 768px) and (max-width: 1400px) {\r\n  .follow-button-follow-more-private-community {\r\n    font-size: 12px;\r\n    margin-bottom: 5px;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n/* default (mobile / small screens) */\r\n.community-name-default-list {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #373334;\r\n  height: 20px;\r\n  display: block;\r\n  width: 100%;\r\n  min-width: 0;\r\n\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* apply width constraints only for ≥1024px */\r\n@media (min-width: 1024px) {\r\n  .community-name-default-list {\r\n    max-width: 160px;\r\n  }\r\n}\r\n@media (min-width: 1440px) {\r\n  .community-name-default-list {\r\n    max-width: 230px;\r\n  }\r\n}\r\n@media (min-width: 1600px) {\r\n  .community-name-default-list {\r\n    max-width: 270px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
